var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
    section: true,
    'section-location': true,
    [`section${_vm.orderNo}`]: true
  }},[_c('a',{staticClass:"navigation-target",attrs:{"id":_vm.hash,"href":"javascript:void(0);"}}),_vm._v(" "),(_vm.data.heading || _vm.data.description)?_c('div',{staticClass:"top-title"},[_c('AtomTitle',{attrs:{"title":_vm.$tdb(_vm.data.heading),"subtitle":_vm.$tdb(_vm.data.description)}})],1):_vm._e(),_vm._v(" "),_c('OrganismLocation',{attrs:{"location-data":_vm.data}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }